/**
 * Composed Chart  component Create Label
 *
 * @package ext-components-base
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import * as am5 from "@amcharts/amcharts5";
import * as am5radar from "@amcharts/amcharts5/radar";

import { ComponentGaugeChart_State } from "./state";
import { IStyles } from "../../types/charts";
import { getStringEnumValue, VERTICAL_ALIGN, VERTICAL_ALIGN_bottom } from "@adapptio/lib-components";

/**
 * Creates label
 */
export function createLabel(
	label: ComponentGaugeChart_State["label"],
	root: am5.Root,
	chart: am5radar.RadarChart,
	value: number,
	styles: IStyles
): am5.Label {
	if (!label) {
		return;
	}

	const verticalAlignValue = getStringEnumValue(VERTICAL_ALIGN, label.verticalAlign, VERTICAL_ALIGN_bottom);
	const centerYValue =
		verticalAlignValue === VERTICAL_ALIGN.TOP
			? 100
			: verticalAlignValue === VERTICAL_ALIGN.MIDDLE
			? 50
			: 0;

	const result = chart.radarContainer.children.push(
		am5.Label.new(root, {
			centerX: am5.percent(50),
			textAlign: "center",
			centerY: am5.percent(centerYValue),
			fontSize: styles.fontSizeLarge
		})
	);

	return result;
}
